export { MorphemeInfoPanelSection } from "#morpheme-info-panel-section";
